<template>
  <div id="app">
      <json-pretty-print></json-pretty-print>
  </div>
</template>

<script>
import JsonPrettyPrint from './components/JsonPrettyPrint.vue'

export default {
  name: 'App',
  components: {
    JsonPrettyPrint
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
